export enum NumerairesEnum {
  BRL = 'BRL',
  CDI = 'CDI',
  EUR = 'EUR',
  IPCA = 'IPCA',
  USD = 'USD',
  BUDGET_CASH_IN_BRL = 'BUDGET_CASH_IN_BRL'
}
